import styled from 'styled-components';

import { getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const ConfirmWrapper = styled.div`
    text-align: center;
    margin-top: auto;
    margin-bottom: auto;
`;

export const CodeContainer = styled.div`
    max-width: 13rem;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: ${getPurpurSpacing('300')};
`;
